const t = (o) => ({
  groupLabel: {
    color: o.palette.common.blue400,
    fontWeight: o.typography.fontWeightBold
  },
  divider: {
    borderColor: o.palette.common.blue100
  },
  formField: {
    width: "100%"
  },
  inputLabel: {
    display: "inline-flex",
    color: o.palette.common.grey500,
    marginBottom: 4
  },
  inputField: {
    border: `1px solid ${o.palette.common.grey100}`,
    backgroundColor: o.palette.common.white,
    borderRadius: 4,
    "& > input, & > textarea": {
      color: o.palette.text.primary,
      fontSize: o.typography.fontSize15,
      lineHeight: 1.2,
      fontWeight: o.typography.fontWeightSemiBold,
      paddingTop: 16,
      paddingBottom: 16,
      "&::placeholder": {
        color: o.palette.common.grey200,
        fontWeight: o.typography.fontWeightRegular
      }
    },
    "& > textarea": {
      padding: 0
    }
  },
  fieldPrefix: {
    height: 10,
    paddingRight: "16px /* @noflip */",
    marginRight: "16px  /* @noflip */",
    borderRight: `1px solid ${o.palette.text.placeholder}  /* @noflip */`,
    "& > p.MuiTypography-root": {
      paddingRight: "12px  /* @noflip */",
      color: o.palette.common.grey400,
      fontSize: o.typography.fontSize15,
      lineHeight: 1.2,
      fontWeight: o.typography.fontWeightSemiBold
    }
  },
  mobileInput: {
    "& input": {
      paddingLeft: "0px  /* @noflip */"
    }
  }
}), i = t;
export {
  i as default
};
